import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "@common/axios";
import ListItemGraphTestAssignment from "@common/ListItemGraphTestAssignment";
import ListItemTestAssignmentPlain from "@common/ListItemTestAssignmentPlain";
import {UserContext} from "@context/UserContext";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import {BrandContext} from "@context/BrandContext";
import ButtonSelect from "@common/ButtonSelect";
import Button from "@common/Button";
import ButtonsGroup from "@common/ButtonsGroup";
import GoToButtonSection from "../components/GoToButtonSection";

const TeacherTestAssignmentsDashboardWidget = props => {
    const {...other} = props,
        [classesProps, setClassesProps] = useState([]),
        [classId, setClassId] = useState(),
        [testAssignments, setTestAssignments] = useState([]),
        [isLoading, setLoading] = useState(true),
        [testAssignmentState, setTestAssignmentState] = useState('ALL'),
        [testPurpose, setTestPurpose] = useState('ALL'),
        {user, setUser} = useContext(UserContext),
        {loadShortcutByUrl} = useCurrentShortcut(),
        brandConfig = useContext(BrandContext),
        [shortcutURL,setShortcutURL] = useState('');

    const testPurposes = [
        {value: 'ALL', label: 'All'},
        {value: 'TEST', label: 'Test'},
        {value: 'DIAGNOSTIC_TEST', label: 'Diagnostic'},
        {value: 'EXAM', label: 'Exam'}
    ];

    const testAssignmentStates = [
        {value: 'ALL', label: 'All'},
        {value: 'AVAILABLE', label: 'Assigned'},
        {value: 'NOT_ASSIGNED', label: 'Not assigned'},
        {value: 'ENDED', label: 'Ended'}
    ];

    useEffect(()=>{
        setShortcutURL('/web/ui/view/teacherAssessments');
    },[]);

    useEffect(() => {
        let newClassesProps = {
            defaultSelected: 0,
            options: []
        };
        newClassesProps.options.push({value: -1, label: 'All'});
        if(user?.classes) {
            user.classes.map(clazz => {
                let option = {
                    value: clazz.classId,
                    label: clazz.className
                }
                newClassesProps.options.push(option);
            });
        }
        setClassesProps(newClassesProps);
    }, [user?.classes]);

    useEffect(() => {
        setLoading(true);
        if(classId !== undefined) {
            setTestAssignments([]);

            if(testAssignmentState === 'ALL') {
                axios.post('/web/ui/test/searchTeacherTestsAndAssignments', {classId: classId === -1 ?  undefined: classId, testPurpose: testPurpose === 'ALL' ? undefined : testPurpose, testAssignmentState: testAssignmentState === 'ALL' ? undefined : testAssignmentState})
                    .then(response => {
                        setTestAssignments(response.data);
                        setLoading(false);
                    });
            } else if(testAssignmentState === 'NOT_ASSIGNED') {
                axios.post('/web/ui/test/searchTeacherTests', {testOwnerSearchType: 'TEACHER', assigned: false, testPurpose: testPurpose === 'ALL' ? undefined : testPurpose})
                    .then(response => {
                        setTestAssignments(response.data);
                        setLoading(false);
                    });
            } else {
                axios.post('/web/ui/test/searchTeacherTestAssignments', {
                    teacherId: user.userId,
                    classId: classId === -1 ? undefined : classId,
                    testPurpose: testPurpose === 'ALL' ? undefined : testPurpose,
                    testAssignmentState: testAssignmentState === 'ALL' ? undefined : testAssignmentState
                })
                    .then(response => {
                        setTestAssignments(response.data);
                        setLoading(false);
                    });
            }
        } else {
            setLoading(false);
        }
    }, [classId, testPurpose, testAssignmentState]);

    const handleTestPurposeChange = selectedOption => {
        setTestPurpose(selectedOption.value);
    }

    const handleTestAssignmentStateChange = selectedOption => {
        setTestAssignmentState(selectedOption.value);
    }

    const handleClassChange = selectedOption => {
        setClassId(selectedOption.value);
    }

    const createTestFromDashBoard = () => {
        globalReactFunctions.createTestFromDashboard = true;
        loadShortcutByUrl(shortcutURL);
    }

    return (
        <>
            {brandConfig.use2025Dashboard &&
                <h2>{brandConfig.testsName}</h2>
            }
            <DashboardWidget
                title={!brandConfig.use2025Dashboard ?
                    <div className="ch-dashboard-title-with-icon">
                        <svg className="ch-icon-medium" viewBox="0 0 128 128">
                            <use href="#tests-icon"></use>
                        </svg>
                        <span>{brandConfig.testsName}</span>
                    </div>
                    : null
                }
                isLoading={isLoading}
                headerActions={
                    <ButtonsGroup>
                        <Button disabled={user.limitedProduct} onClick={createTestFromDashBoard}>Create a test</Button>
                        {(brandConfig.enableExams || brandConfig.enableDiagnosticTests) &&
                            <ButtonSelect title="Type" type="outline" options={testPurposes} value={testPurpose !== undefined ? testPurposes.find(o => o.value === testPurpose) : 'ALL'} onChange={handleTestPurposeChange}/>
                        }
                        {user.brandCode != 'USA' &&
                            <ButtonSelect title="Status" type="outline" options={testAssignmentStates}
                                          value={testAssignmentState !== undefined ? testAssignmentStates.find(o => o.value === testAssignmentState) : 'ALL'}
                                          onChange={handleTestAssignmentStateChange}/>
                        }
                        <ButtonSelect title="Class" type="outline" options={classesProps.options} value={classesProps.defaultSelected !== undefined ? classesProps.options[classesProps.defaultSelected] : ''} onChange={handleClassChange}/>
                    </ButtonsGroup>
                }
                {...other}>
                <div className={"ch-dashboard-blk-body"}>
                    {(testAssignments && testAssignments.length > 0) &&
                        <table className={'ch-dashboard-widget-table ch-table'}>
                            <thead>
                                <tr>
                                    {(brandConfig.enableExams || brandConfig.enableDiagnosticTests) &&
                                        <th>Type</th>
                                    }
                                    <th>{brandConfig.testsName.substr(0,brandConfig.testName.length)} name</th>
                                    <th>Created by</th>
                                    <th>Status</th>
                                    <th>Average score</th>
                                    <th>Students completed</th>
                                </tr>
                            </thead>
                            <tbody>
                            {testAssignments.map((testAssignment, index) =>
                                <ListItemTestAssignmentPlain key={index} testAssignment={testAssignment} />
                            )}
                            </tbody>
                        </table>
                    }
                    {(testAssignments.length == 0) &&
                        <div className="ch-list-item-disabled">No assigned {brandConfig.testsName}</div>
                    }
                </div>
                <GoToButtonSection buttonText={'Go to all my ' + brandConfig.testsName.toLowerCase()}
                                   onClick={() => loadShortcutByUrl(shortcutURL)}
                                   disabled={user.limitedProduct}/>
            </DashboardWidget>
        </>
    )
}

export default TeacherTestAssignmentsDashboardWidget;
